<template>
  <div class="py-24 lg:py-4 lg:pb-20 xl:py-32 flex flex-col items-center px-5">
    <img src="@/assets/images/error404.png">
    <p class="mt-4 mb-10 text-xl">This page does not exist</p>
    <img src="@/assets/images/errorReaction.jpg" style="max-width: 680px;">
  </div>
</template>
